import fetch from '@/apiconfig/index';

export  function toSuitAblePageByEmp(parameter) {
  return fetch({
    url:'/api/companystaff/easyRegisterController/toSuitAblePageByEmp',
    method:'get',
    params:parameter
  });
}


export function employeeHttpAction(url, parameter, type) {
  return fetch({
    url: '/api/companystaff' + url,
    method: type,
    data: parameter
  });
}

export function employeeGetAction(url, parameter) {
  return fetch({
    url: '/api/companystaff/' + url,
    method: 'get',
    params: parameter
  });
}
//添加微信支付
export function saveWechatPayToUser(data) {
    return fetch({
      url: '/api/companystaff/employeeBankCard/saveWechatPayToUser',
      method: 'post',
      data:data
    });
  }
//获取当前登录用户的部分信息
export function employeeGetActiveUserPartInfo() {
  return fetch({
    url: '/api/companystaff/employeeAccount/info/getActiveUserPartInfo',
    method: 'get',
  });
}

//获取当前登录用户支付宝
export function employeeFindAlipayListByActiveUser() {
    return fetch({
        url: '/api/companystaff/employeeBankCard/findAlipayListByActiveUser',
        method: 'get',
    });
}

//判断当前人力公司是否支持 支付宝 付款方式
export function checkSupportAliPay(ocompanyId) {
  return fetch({
    url: '/api/companystaff/employeeBankCard/checkSupportAliPay?ocompanyId=' + ocompanyId,
    method: 'get',
  });
}

//获取当前登录用户所有的银行卡信息
export function employeeFindListByActiveUser() {
  return fetch({
    url: '/api/companystaff/employeeBankCard/findListByActiveUser',
    method: 'get',
  });
}
//认证当前银行卡
export function employeeBankCardCate(id) {
  return fetch({
    url: '/api/companystaff/employeeBankCard/employeeBankCardCate/' + id,
    method: 'get',
  });
}

export function employeePasswordValidate(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/passwordValidate',
    method: 'post',
    data: parameter
  });
}

export function employeePostAction(url, parameter) {
  return fetch({
    url: '/api/companystaff' + url,
    method: 'post',
    data: parameter
  });
}

export function employeePutAction(url, parameter) {
  return fetch({
    url: '/api/companystaff' + url,
    method: 'put',
    data: parameter
  });
}

export function employeePatchAction(url, parameter) {
  return fetch({
    url: '/api/companystaff' + url,
    method: 'patch',
    data: parameter
  });
}


//用户设置openid
export function employeeSetOidByCode(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/setOidByCode',
    method: 'patch',
    data: parameter
  });
}
//用户设置密码
export function setEmployeePassword(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/setPassword',
    method: 'patch',
    data: parameter
  });
}
//用户忘记密码
export function employeeForgetPassword(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/forgetPassword',
    method: 'put',
    data: parameter
  });
}

//用户重新设置密码
export function employeeSetHeadshot(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/setHeadshot',
    method: 'patch',
    data: parameter
  });
}

export function setEmployeeResetPassword(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/resetPassword',
    method: 'patch',
    data: parameter
  });
}
export function employeeDeleteAction(url, parameter) {
  return fetch({
    url: '/api/companystaff' + url,
    method: 'delete',
    data: parameter
  });
}
//删除银行卡
export function employeeBankCardDeleteAction(id) {
  return fetch({
    url: '/api/companystaff/employeeBankCard/delete/' + id,
    method: 'delete',
  });
}

export function saveIdCard(obj) {
  return fetch({
    url:'/api/companystaff/employeeAccount/saveIdCard',
    method:'post',
    data:obj
  })

}
//上传身份证图片认证身份信息
export function saveEmployeeAccountMessage(obj) {
    return fetch({
      url:'/api/companystaff/easyRegisterController/saveEmployeeAccountMessage',
      method:'post',
      data:obj
    })
  
  }

export function employeeSaveToUserToCode(parameter) {
  return fetch({
    url: '/api/companystaff/employeeBankCard/saveToUserToCode',
    method: 'post',
    data: parameter
  });
}

export function employeeSaveToUserToFile(parameter) {
  return fetch({
    url: '/api/companystaff/employeeBankCard/saveToUserToFile',
    method: 'post',
    data: parameter
  });
}

export function updateResume(parameter) {
  return fetch({
    url: '/api/companystaff/employeeAccount/updateResume',
    method: 'post',
    data: parameter
  });
}

//校验支付方式是否有支付宝
export function checkPayType() {
  return fetch({
    url: '/api/companystaff/employeeBankCard/checkPayType',
    method: 'get',
  });
}
//上传身份证图片认证身份信息 新
export function getMessageFromIdCard(obj) {
    return fetch({
      url:'/api/companystaff/easyRegisterController/getMessageFromIdCard',
      method:'post',
      data:obj
    })
  
  } 

  
//三要素认证 简易邀请注册
export function simVerifyUser(obj) {
    return fetch({
      url:'/api/companystaff/easyRegisterController/verifyUser',
      method:'post',
      data:obj
    })
  
  }
  export function saveToUserToCode(parameter) {
    return fetch({
      url: '/api/companystaff/easyRegisterController/saveToUserToCode',
      method: 'post',
      data: parameter
    });
  }